'use client';

import React from 'react';
import Link from 'next/link';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sans">
      <Header />

      <main className="flex-1 flex flex-col items-center justify-center p-8 text-center animate-fade-in-up">
        {/* Large 404 Graphic element */}
        <div className="relative mb-8 text-teal-600/10 select-none">
          <h1 className="text-[12rem] md:text-[18rem] font-black leading-none tracking-tighter">404</h1>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            {/* Overlay actual title over the faint 404 */}
            <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-4 shadow-sm border border-red-200">
               <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                 <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
               </svg>
            </div>
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 tracking-tight">Page Not Found</h2>
          </div>
        </div>

        <p className="max-w-md mx-auto text-lg text-gray-500 mb-10 leading-relaxed font-medium">
          The page you are looking for doesn't exist or has been moved. Let's get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 justify-center">
           <button onClick={() => window.history.back()} className="w-full sm:w-auto px-6 py-3 border-2 border-gray-200 text-gray-700 bg-white rounded-xl font-bold hover:bg-gray-50 hover:border-gray-300 transition-all shadow-sm">
             Go Back
           </button>
           <Link href="/" className="w-full sm:w-auto px-6 py-3 bg-teal-600 text-white rounded-xl font-bold hover:bg-teal-700 transition-all shadow-sm">
             Return Home
           </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}
